'use strict';

angular.module('app')
  .factory('Wishlist', function($rootScope, Request, GTM, gettextCatalog) {
    var Wishlist = {}


    Wishlist.get = function() {
      return Request.get('account/wishlist/').then(function(res) {
        return _.sortByOrder(res.data, 'id', 'desc');
      });
    };

    Wishlist.add = function(data) {
      return Request.post('account/wishlist/add/', data).then(function(res) {
        GTM.event('wishlist_add_item');
        GTM.variables({
          'wishlist_last_item_used': res.data
        });

        $rootScope.showNotify(data.item_type === "Shop" ? gettextCatalog.getString('This dive operator has successfully been added to your wishlist') : gettextCatalog.getString('This element has successfully been added to your wishlist'));
        return res.data;
      });
    };

    Wishlist.delete = function(id) {
      return Request.del('account/wishlist/delete/' + id + '/').then(function(res) {
        GTM.event('wishlist_remove_item');
        GTM.variables({
          'wishlist_last_item_used': res.data
        });
        return res.data;
      });
    };

    return Wishlist;

  });